export const DYNAMIC_REPORTS_ARE_FETCHING = 'DYNAMIC_REPORTS_ARE_FETCHING';
export const DYNAMIC_REPORTS_GET_SUCCESS = 'DYNAMIC_REPORTS_GET_SUCCESS';
export const DYNAMIC_REPORTS_GET_ERROR = 'DYNAMIC_REPORTS_GET_ERROR';
